(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["common-friends-homepage"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cfc-coffee-carousel')) {
    customElements.define('cfc-coffee-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.cfc-home__coffee-grid');
        this.toggle = this.querySelector('[data-toggle]');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.motion.matches;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.querySelector('.cfc-home__carousel-controls').hidden = false;
        this.querySelector('[data-previous]').addEventListener('click', () => { this.stop(); this.advance(-1); }, options);
        this.querySelector('[data-next]').addEventListener('click', () => { this.stop(); this.advance(1); }, options);
        this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.updateLabel(); this.schedule(); }, options);
        this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => this.schedule(), options);
        this.addEventListener('focusout', () => queueMicrotask(() => this.schedule()), options);
        this.track.addEventListener('pointerdown', () => this.stop(), options);
        this.track.addEventListener('wheel', () => this.stop(), { ...options, passive: true });
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => { if (this.motion.matches) this.stop(); }, options);
        this.updateLabel();
        this.schedule();
      }
      disconnectedCallback() { clearTimeout(this.timer); this.abort.abort(); }
      updateLabel() { this.toggle.textContent = this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel; }
      stop() { this.paused = true; this.updateLabel(); this.schedule(); }
      schedule() {
        clearTimeout(this.timer);
        if (this.paused || this.hovered || this.contains(document.activeElement) || document.hidden) return;
        this.timer = setTimeout(() => { this.advance(1); this.schedule(); }, 6000);
      }
      advance(direction) {
        const card = this.track.querySelector('.cfc-home__coffee-card');
        if (!card) return;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap);
        const max = this.track.scrollWidth - this.track.clientWidth;
        const current = this.track.scrollLeft;
        let target = current + step * direction;
        if (direction > 0 && current >= max - 4) target = 0;
        if (direction < 0 && current <= 4) target = max;
        this.track.scrollTo({ left: target, behavior: this.motion.matches ? 'instant' : 'smooth' });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
